import React, { memo } from 'react';
import { ArrowLeft, Check, ArrowRight } from 'lucide-react';

const KeypadButton = memo(({ children, onClick, className = '', variant = 'default', disabled = false }) => {
  const baseStyles = "flex-1 h-14 text-xl font-medium rounded-xl transition-all flex items-center justify-center active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed";
  const variants = {
    default: "bg-white dark:bg-gray-800 border dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700",
    delete: "bg-red-50 dark:bg-red-900/20 text-red-600 dark:text-red-400 border-red-100 dark:border-red-800 hover:bg-red-100 dark:hover:bg-red-900/40",
    confirm: "bg-green-500 hover:bg-green-600 active:bg-green-700 text-white border-0 disabled:bg-gray-300 dark:disabled:bg-gray-600",
    tab: "bg-blue-50 dark:bg-blue-900/20 text-blue-600 dark:text-blue-400 border-blue-100 dark:border-blue-800 hover:bg-blue-100 dark:hover:bg-blue-900/40"
  };

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      type="button"
      className={`${baseStyles} ${variants[variant]} ${className}`}
    >
      {children}
    </button>
  );
});

const NumericKeypad = memo(({ 
  onInput, 
  onDelete, 
  onConfirm, 
  onNext,
  hasNext = false,
  isLoading = false,
  disabled = false 
}) => {
  const handleKeyClick = (value) => {
    onInput(value);
  };

  return (
    <div className="bg-gray-50 dark:bg-gray-900 p-3 space-y-2">
      <div className="grid grid-cols-3 gap-2">
        {[7, 8, 9, 4, 5, 6, 1, 2, 3].map((num) => (
          <KeypadButton key={num} onClick={() => handleKeyClick(num)}>
            {num}
          </KeypadButton>
        ))}
        <KeypadButton onClick={onDelete} variant="delete">
          <ArrowLeft className="w-5 h-5" />
        </KeypadButton>
        <KeypadButton onClick={() => handleKeyClick(0)}>
          0
        </KeypadButton>
        {hasNext ? (
          <KeypadButton 
            onClick={onNext}
            variant="tab"
            className="text-lg"
          >
            <ArrowRight className="w-5 h-5" />
          </KeypadButton>
        ) : (
          <KeypadButton 
            onClick={onConfirm}
            variant="confirm"
            disabled={disabled}
            className="text-lg relative"
          >
            {isLoading ? (
              <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
            ) : (
              <Check className="w-5 h-5" />
            )}
          </KeypadButton>
        )}
      </div>
    </div>
  );
});

NumericKeypad.displayName = 'NumericKeypad';
KeypadButton.displayName = 'KeypadButton';

export default NumericKeypad; 